/* src/app/components/payroll/timesheets/timesheet-payroll-processing/add-timesheet-payroll-batch/add-timesheet-payroll-batch.component.css */
.details-header {
  display: flex;
  align-items: center;
  gap: 16px;
}
ppl-accordion {
  display: block;
  width: 100%;
}
.ppl-content-container {
  overflow-x: hidden;
}
.body-scroll {
  padding: 8px;
  max-height: calc(100vh - 140px);
  box-sizing: border-box;
}
.wiz-body {
  align-items: flex-start;
  gap: 12px;
  align-self: stretch;
  padding: 12px;
}
.section-label-row {
  display: flex;
  align-items: center;
  justify-content: space-between;
  gap: 12px;
  margin-bottom: 8px;
  width: 100%;
}
.section-hint {
  margin: 0;
  font-size: 13px;
  color: #8c8c8c;
}
.input-section {
  width: 100%;
}
.batch-type-row {
  display: flex;
  gap: 16px;
  margin-bottom: 16px;
}
.batch-type-field {
  display: flex;
  flex-direction: column;
  gap: 4px;
  flex: 0 1 280px;
}
.required-marker {
  color: #d32f2f;
}
.or-divider {
  display: flex;
  align-items: center;
  width: 100%;
  margin: 20px 0;
}
.or-divider::before,
.or-divider::after {
  content: "";
  flex: 1;
  border-bottom: 1px solid #d9d9d9;
}
.or-divider-text {
  padding: 0 16px;
  font-size: 14px;
  font-weight: 600;
  color: #8c8c8c;
  text-transform: uppercase;
  letter-spacing: 1px;
}
.table-wrapper {
  width: 100%;
}
.criteria-table {
  width: 100%;
  border-collapse: separate;
  border-spacing: 0;
}
.col-field {
  width: 25%;
  padding-left: 10px;
}
.col-actions {
  width: 15%;
  padding-left: 10px;
}
.cell {
  vertical-align: middle;
  padding: 10px;
}
.cell-actions {
  white-space: nowrap;
}
.action-btn {
  margin-right: 4px;
}
.action-btn-danger {
  color: #d32f2f;
}
.full-width {
  width: 100%;
}
.value-range {
  display: flex;
  gap: 8px;
  align-items: flex-start;
}
.value-range-field {
  flex: 1 1 0;
  min-width: 0;
}
.validation-error {
  display: block;
  color: #d32f2f;
  font-size: 12px;
  margin-top: 4px;
}
.details-grid {
  display: grid;
  grid-template-columns: repeat(auto-fit, minmax(240px, 1fr));
  gap: 12px 24px;
  margin: 0;
  width: 100%;
}
.details-item dt {
  font-size: 12px;
  color: #8c8c8c;
  margin-bottom: 2px;
}
.details-item dd {
  margin: 0;
  font-size: 14px;
  color: rgba(0, 0, 0, 0.85);
  word-break: break-word;
}
.criteria-table.read-only th {
  font-size: 12px;
  font-weight: 600;
  color: #8c8c8c;
  text-transform: uppercase;
  letter-spacing: 0.4px;
}
.criteria-table.read-only td {
  border-bottom: 1px solid #f0f0f0;
  font-size: 14px;
}
/*# sourceMappingURL=add-timesheet-payroll-batch.component-6HMG3FGX.css.map */
